import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { PaymentStatusEnum } from '../enums/payment-status.enum';

/**
 * Maps the payment status value to a color value for UI styling
 */
export function paymentStatusToColor(
	status: PaymentStatusEnum | undefined | null,
): string {
	if (!status) {
		return RecordColorEnum.DEFAULT;
	}
	switch (status) {
		case PaymentStatusEnum.COMPLETED:
			return RecordColorEnum.GREEN;
		case PaymentStatusEnum.CANCELLED:
		case PaymentStatusEnum.FAILED:
		case PaymentStatusEnum.EXPIRED:
		case PaymentStatusEnum.REFUNDED:
			return RecordColorEnum.NEUTRAL;
		case PaymentStatusEnum.PROCESSING:
		case PaymentStatusEnum.RETRYING:
			return RecordColorEnum.AMBER;
		case PaymentStatusEnum.PENDING:
		default:
			return RecordColorEnum.DEFAULT;
	}
}
